import { Directive, HostListener, AfterViewInit } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appZip]'
})
export class ZipDirective implements AfterViewInit {

  constructor(private ngControl: NgControl) {}

  ngAfterViewInit() {
    this.formatValue();
  }

  @HostListener('input')
  @HostListener('blur')
  onInputOrBlur() {
    this.formatValue();
  }
  private formatValue() {
    const control = this.ngControl.control;
    if (!control?.value) return;

    let value = control.value.toString();
    value = value.replace(/[^0-9-]/g, '');
    const hyphenCount = (value.match(/-/g) || []).length;
    if (hyphenCount > 1) {
      value = value.replace(/-/g, (match: string, offset: number) =>
        offset === value.indexOf('-') ? '-' : ''
      );
    }
    const digits = value.replace(/-/g, '');
    let limitedDigits = digits.substring(0, 9);
    let formatted = limitedDigits;

    if (value.includes('-')) {
      if (limitedDigits.length > 5) {
        formatted = limitedDigits.substring(0, 5) + '-' + limitedDigits.substring(5);
      } else {
        formatted = limitedDigits.substring(0, 5) + '-';
      }
    }

    if (formatted !== control.value) {
      control.setValue(formatted, { emitEvent: true });
    }

    control.markAsTouched();
    control.updateValueAndValidity({ emitEvent: false });
  }
}